import { render, staticRenderFns } from "./HistoryTransportInfo.vue?vue&type=template&id=207d795b&scoped=true&"
import script from "./HistoryTransportInfo.vue?vue&type=script&lang=js&"
export * from "./HistoryTransportInfo.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTransportInfo.vue?vue&type=style&index=0&id=207d795b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d795b",
  null
  
)

export default component.exports